import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Only throw if we are actually running the app (not during tests/build if envs are missing)
// But for development, we want to know immediately.
if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('Missing Supabase environment variables');
}

export const supabase = createClient<Database>(supabaseUrl || '', supabaseAnonKey || '', {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
    },
    global: {
        headers: {
            'x-app-version': import.meta.env.VITE_APP_VERSION || '1.0.0',
        },
    },
});

// Helper para verificar se usuário está bloqueado
export async function checkIfBlocked(userId: string): Promise<boolean> {
    const { data, error } = await supabase.rpc('is_user_blocked', { user_id: userId });
    if (error) {
        console.error('Error checking blocked status:', error);
        return false;
    }
    return data || false;
}

// Helper para verificar se dia está liberado
export async function checkDiaLiberado(userId: string, dia: number): Promise<boolean> {
    const { data, error } = await supabase.rpc('dia_esta_liberado', {
        p_user_id: userId,
        p_dia: dia,
    });
    if (error) {
        console.error('Error checking day availability:', error);
        return false;
    }
    return data || false;
}



// Helper para upload de fotos
export async function uploadFoto(
    userId: string,
    file: File,
    tipo: 'antes' | 'depois',
    posicao: 'frente' | 'costa' | 'lado'
): Promise<{ url: string; path: string }> {
    const fileExt = file.name.split('.').pop();
    const fileName = `${userId}/${tipo}/${posicao}_${Date.now()}.${fileExt}`;

    const { error: uploadError } = await supabase.storage
        .from('evolution_photos')
        .upload(fileName, file, {
            cacheControl: '3600',
            upsert: false,
        });

    if (uploadError) throw uploadError;

    const { data: urlData } = supabase.storage
        .from('evolution_photos')
        .getPublicUrl(fileName);

    return {
        url: urlData.publicUrl,
        path: fileName,
    };
}
